import React from 'react';

import { TextField, useRecordContext } from 'react-admin';

import { get, isEmpty } from 'lodash';

import { Typography } from '@mui/material';

import Answer from '../Answer';

import languages, { Languages } from '../../../../constants/languages';
import conflictFields from '../../../../constants/conflictFields';
import getCoefficientFromPeriod from '../../../../utilities/getCoefficiantFromPeriod';
import { SalaryParameters } from '../../questionParameters';

const VALUE_LABEL = {
  [languages.SV]: 'Månadsinkomst',
  [languages.EN]: 'Salary',
  [languages.DE]: 'Monatliches Einkommen',
};

const ValueField = ({
  extraParameters,
}: {
  extraParameters?: SalaryParameters;
  language?: Languages;
}) => {
  const record = useRecordContext();

  const valueObj = get(record, 'value');
  const sx = get(record, 'sx', {});

  if (isEmpty(valueObj)) return <Typography>-</Typography>;

  const value = `${valueObj.value * getCoefficientFromPeriod(extraParameters?.unit, extraParameters?.period)} ${valueObj.currency}`;

  return <TextField record={{ value }} sx={sx} source="value" emptyText="-" fontWeight="bold" />;
};

const Salary = ({ extraParameters }: {
  extraParameters?: SalaryParameters;
}) => {
  const record = useRecordContext();

  const language = record?.language as Languages;

  return (
    <Answer
      label={extraParameters?.label ?? VALUE_LABEL[language]}
      source="salary"
      datapoint={conflictFields.INCOME}
      identificationInfo={undefined}
    >
      <ValueField extraParameters={extraParameters} />
    </Answer>
  );
};

Salary.ValueField = ValueField;

export default Salary;
